module.exports = __webpack_public_path__ + "img/kieswijs_logo_background.bb776832.png";